/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Bad_RequestInputs */



/**
* | output |
* | --- |
* | "The request could not be processed. Please try again." |
*
* @param {Chat_Error_Bad_RequestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_bad_request = /** @type {((inputs?: Chat_Error_Bad_RequestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Bad_RequestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Anfrage konnte nicht verarbeitet werden. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("The request could not be processed. Please try again.")
});